import { computed } from 'ccstate'
import { supabaseCurrentUser$ } from '../infra/authClient'

export const sharedCurrentUserState = {
  currentUser$: computed(async (get) => {
    return await get(supabaseCurrentUser$)
  })
}